import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../utils/Functions';


const TransomFiveGridBlackWindow = ({ width, height, trimWidth, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])


    const outTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        hole.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const innerTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        model.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth * 2, height / 2 - trimWidth * 2);
        hole.lineTo(width / 2 - trimWidth * 2, height / 2 - trimWidth * 2);
        hole.lineTo(width / 2 - trimWidth * 2, -height / 2 + trimWidth * 2);
        hole.lineTo(-width / 2 + trimWidth * 2, -height / 2 + trimWidth * 2);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - trimWidth), height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -(height / 2 - trimWidth));
        model.lineTo(-(width / 2 - trimWidth), -(height / 2 - trimWidth));
        model.closePath();

        return model;
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        const railThickness = trimWidth / 5 * 2
        const railHeight = height - trimWidth * 2;

        const model = new THREE.Shape();
        model.moveTo(railThickness, -railHeight / 2 + trimWidth);
        model.lineTo(railThickness, railHeight / 2 - trimWidth);
        model.lineTo(-(railThickness), railHeight / 2 - trimWidth);
        model.lineTo(-(railThickness), -railHeight / 2 + trimWidth);

        return model;
    }, [height])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[outTrimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='inner-trim' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[innerTrimModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={'#1F1F1F'} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            {new Array(2).fill('').map((_, index) =>
                <mesh name='rail' position={[-width / 10.5 * (2 * index + 1), 0, 0.05]}>
                    <extrudeGeometry args={[railModel, extrudeSettings(0.2)]} />
                    <meshStandardMaterial  color={'#1F1F1F'} side={THREE.DoubleSide} roughness={0.3} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>
            )}
            {new Array(2).fill('').map((_, index) =>
                <mesh name='rail' position={[width / 10.5 * (2 * index + 1), 0, 0.05]}>
                    <extrudeGeometry args={[railModel, extrudeSettings(0.2)]} />
                    <meshStandardMaterial  color={'#1F1F1F'} side={THREE.DoubleSide} roughness={0.3} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>
            )}
          
            <mesh name='glass' position={[0, 0, 0.075]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.15)]} />                
                <meshPhongMaterial color={'#1f1e1e'} side={THREE.DoubleSide}reflectivity={0.5} metalness={0.2} toneMapped={false} />                        
            </mesh>
        </>
    )
}

export default TransomFiveGridBlackWindow